import { render, staticRenderFns } from "./ServiceObjectMapPopupReport.vue?vue&type=template&id=08bc56f7&scoped=true&"
import script from "./ServiceObjectMapPopupReport.vue?vue&type=script&lang=js&"
export * from "./ServiceObjectMapPopupReport.vue?vue&type=script&lang=js&"
import style0 from "./ServiceObjectMapPopupReport.vue?vue&type=style&index=0&id=08bc56f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc56f7",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QTooltip,QItem,QInput,QExpansionItem} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QIcon,QTooltip,QItem,QInput,QExpansionItem}, component.options.components || {})
